<template>
  <TksCalculatingList />
</template>

<script>
import TksCalculatingList from "@/components/Calculatings/TksCalculating/List.vue";
export default {
  components: { TksCalculatingList },
};
</script>

<style></style>
